import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ShieldAlert, ShieldCheck, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function SecurityDenyPage() {
  const [params] = useSearchParams();
  const { user, logout } = useAuth();
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const body = { u: params.get("u"), c: params.get("c"), t: params.get("t") };
  const isLogin = (body.c || "").startsWith("login-");

  const deny = async () => {
    setBusy(true); setError("");
    try {
      await api.post("/auth/change-password/deny", body);
      setDone(true);
      if (user) logout();
    } catch (e) { setError(e.response?.status === 422 ? "This link isn't valid. Use the button in your email." : errMsg(e)); } finally { setBusy(false); }
  };

  const Icon = done ? ShieldCheck : ShieldAlert;
  return (
    <div className="flex min-h-screen items-center justify-center lf-glow lf-grain p-6" data-testid="security-deny-page">
      <div className="relative z-10 w-full max-w-md text-center">
        <Icon className={`mx-auto h-10 w-10 ${done ? "text-[#34D399]" : "text-[#F87171]"}`} />
        <h1 className="mt-5 font-display text-4xl text-[#F3EBDD]" data-testid="security-deny-title">{done ? (isLogin ? "Every device is signed out." : "Change cancelled.") : isLogin ? "Wasn't you signing in?" : "Didn't ask to change your password?"}</h1>
        <p className="mt-2 text-sm text-[#A8A090]">
          {done ? `${isLogin ? "" : "Your password was not changed, and "}every device has been signed out of LoreRight. Someone may know your password, so reset it now.`
            : isLogin ? "We'll sign your account out on every device, including the one that just signed in. Then you can choose a new password."
            : "We'll cancel the pending password change and sign your account out on every device."}
        </p>
        {!body.u || !body.c || !body.t ? <p className="mt-6 text-sm text-[#F87171]">This link is incomplete. Use the button in your email.</p> : !done && (
          <Button className="mt-8 bg-[#B91C1C] text-white hover:bg-[#991B1B]" onClick={deny} disabled={busy} data-testid="security-deny-button">
            {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}{isLogin ? "This wasn't me: sign out everywhere" : "I didn't request this: stop it and sign out everywhere"}
          </Button>
        )}
        {error && <p className="mt-4 text-sm text-[#F87171]" data-testid="security-deny-error">{error}</p>}
        {done && <Link to="/forgot-password" className="mt-8 inline-block rounded-full bg-[#F59E0B] px-5 py-2 text-sm font-medium text-[#0B0D10]" data-testid="security-reset-link">Reset my password</Link>}
      </div>
    </div>
  );
}
